module.exports = __webpack_public_path__ + "static/media/logoBannerTopMP4.c1d454bb.mp4";